import { LOGIN } from "../lib/constants/actions";
export const loginReducer = (state = {}, action) => {
    switch (action.type) {
        case LOGIN.LOGIN_SUCCESS:
            return { ...state, loginSuccess: action.payload }
        case LOGIN.CHANGE_PASSWORD_SUCCESS:
            return { ...state, passwordChanged: action.payload }
        case LOGIN.RESET_PASSWORD_SUCCESS:
            return { ...state, passwordReset: action.payload }
        case LOGIN.VERIFY_OTP_SUCCESS:
            return { ...state, loginData: action.payload }
        default:
            return state;
    }
};




